<div class="multi-select-wrapper" appClickOutside (appClickOutside)="opened = false">
  <div class="header">
    <div><label class="title">{{ label }}<span *ngIf="isRequired" class="required"> *</span></label></div>
    <div><label *ngIf="Reset" class="reset-section" (click)="reset()">{{ Reset }}</label></div>
  </div>
  
  <div class="dropdown-wrapper">
    <app-button
      [kind]="buttonOption.kind"
      [icon]="opened ? 'icon-arrow-up-12' : 'icon-arrow-down-12'"
      [isDisabled]="isDisabled"
      [class.error-border]="isRequired && !selected.length && PreferenceInitialLoad"
      [class.placeholder]="allUnChecked()"
      (clicked)="opened = !opened"
      [label]="text"
      ></app-button
    >
    <ng-container *ngIf="opened">
      <div class="list-wrapper">
        <div style="margin-bottom: 12px;" *ngIf="isIncludeDeleted">
          <app-checkbox
            style="margin-bottom: 20px"
            [label]="'Translation.Includedeleted' | translate"
            [theme]="BLUE_THEME"
            [value]="includeDeletedValue"
            (stateChanged)="stateChange($event)"   
          >
          </app-checkbox>
        </div>
        <div *ngIf="!groups"> 
        <app-checkbox-group>
          <app-checkbox
            *ngIf="tickAllDisplay"
            [label]="all?.label"
            [theme]="BLUE_THEME"
            [value]="all?.isChecked"
            [isIndeterminate]="all?.isIndeterminate"
            (stateChanged)="changeAllOption($event)"
          >
          </app-checkbox>
          <div *ngFor="let item of list" class="checkbox" [ngClass]="item.isDisabled ? 'disable-btn' : 'enable-btn'">
            <app-checkbox [theme]="BLUE_THEME"
                          [value]="item?.isChecked"
                          (stateChanged)="changeItem($event, item.id)"
                          [label] ='item?.label || item?.name'
                          [iconClass]="showIcon ? item?.icon :''">
            </app-checkbox>
          </div>
        </app-checkbox-group>
      </div>
      <div *ngIf="groups">
        <div class="group-select" *ngFor="let items of groups">
          <div><span>{{items.label}}</span></div>
          <div>
          <app-checkbox-group>
            <app-checkbox
              *ngIf="tickAllDisplay"
              [label]="all?.label"
              [theme]="BLUE_THEME"
              [value]="items.isAllChecked"
              [isIndeterminate]="items.isAllIndeterminate"
              (stateChanged)="changeAllOption($event,items.id)"
            >
            </app-checkbox>
            <div *ngFor="let item of getGroupData(items.id)" class="checkbox" [ngClass]="item.isDisabled ? 'disable-btn' : 'enable-btn'">
              <app-checkbox [theme]="BLUE_THEME"
                            [value]="item?.isChecked"
                            (stateChanged)="changeItem($event, item.id, items.id)"
                            label ='{{ item?.displayName | translate }}'
                            [iconClass]="showIcon ? item?.icon :''">
              </app-checkbox>
            </div>
          </app-checkbox-group>
        </div>
        </div>
      </div>
      </div>
    </ng-container>
    <div class="required" *ngIf="!selected.length && isRequired && PreferenceInitialLoad" [style.margin-top]="'4px'">{{ errorMessage | translate }}</div>
  </div>
  <div *ngIf="selected.length && showChips">
    <app-tags>
      <app-tag
        *ngFor="let chip of chips | slice : 0 : limit"
        [isDisabled]="isDisabled"
        [isRemovable]="true"
        (removed)="changeItem(false, chip.id, chip.groupId)"
        [label]="chip?.label | translate"
        ></app-tag>
    </app-tags>
    <div *ngIf="chips.length > showMoreLimit">
      <label class="show-more" *ngIf="showMore" (click)="showMore = false">{{ "Translation.Showless" | translate }}</label>
      <label class="show-more" *ngIf="!showMore" (click)="showMore = true">{{ "Translation.Showmore" | translate }}</label>
    </div>
  </div>
</div>
